import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { deleteJob, getJob, getJobs, postJob, updateJob } from './JobsApi';

const initialState = {
  allJobs: [],
  jobDetails:{},
  isLoading: false,
  isError: false,
  error: "",
  editJob: {},
  isUpdateJobSuccessFull:false
}

export const getAllJobs = createAsyncThunk('jobs/getJobs',async(data)=>{
    
    const response = await getJobs();
  
    return response.data
})
export const postSingleJob = createAsyncThunk('jobs/postJob',async(data)=>{
    
    const response = await postJob(data);

    return response.data
})
export const getSingleJob = createAsyncThunk('jobs/getJob',async(id)=>{
    
    const response = await getJob(id);

    return response.data
})
export const deleteSingleJob = createAsyncThunk('jobs/deleteJob',async(id)=>{
    
    const response = await deleteJob(id);

    return response.data
})
export const updateSingleJob = createAsyncThunk('jobs/updtaeJob',async(data)=>{
    
    const response = await updateJob(data);

    return response.data
})

export const jobSlice = createSlice({
  name: 'getJobs',
  initialState,
  reducers:{
editSingleJob:(state,action)=>{
state.editJob=action.payload;
}
,
resetEditJob:(state)=>{
state.editJob={};
},
resetToggleisUpdateJobSuccessFull:(state)=>{
state.isUpdateJobSuccessFull=false;
},

  },
 
  extraReducers:(buider)=>{
    buider
    .addCase(getAllJobs.pending,(state,action)=>{
        state.isError = false;
        state.isLoading = true;
    })

    .addCase(getAllJobs.fulfilled,(state,action)=>{
        state.allJobs=action.payload;
        state.isLoading = false;
        state.isError = false;
        state.error = ''



    })
   
    .addCase(getAllJobs.rejected,(state,action)=>{
        state.isLoading = false;
        state.allJobs = [];
        state.isError = true;
        state.error = action.error?.message

    })
    .addCase(postSingleJob.pending,(state,action)=>{
        state.isError = false;
        state.isLoading = true;
    })

    .addCase(postSingleJob.fulfilled,(state,action)=>{
       
        state.isLoading = false;
        state.isError = false;
        state.error = ''
 })
   
    .addCase(postSingleJob.rejected,(state,action)=>{
        state.isLoading = false;
        state.allJobs = [];
        state.isError = true;
        state.error = action.error?.message

    })
    .addCase(deleteSingleJob.pending,(state,action)=>{
        state.isError = false;
        state.isLoading = true;
    })

    .addCase(deleteSingleJob.fulfilled,(state,action)=>{
      
        state.allJobs = state.allJobs.filter(job=> job.id !== action?.meta?.arg)
        toast.success('Successfully deleted job')
        state.isLoading = false;
        state.isError = false;
        state.error = ''
 })
   
    .addCase(deleteSingleJob.rejected,(state,action)=>{
       
        state.isLoading = false;
        // state.allJobs = [];
        state.isError = true;
        state.error = action.error?.message

    })
    .addCase(updateSingleJob.pending,(state,action)=>{
        state.isError = false;
        state.isLoading = true;
        state.isUpdateJobSuccessFull = false;

    })

    .addCase(updateSingleJob.fulfilled,(state,action)=>{
      console.log('action', action)
        state.allJobs[action?.payload?.id] = action.payload

        state.isUpdateJobSuccessFull = true;
        state.isLoading = false;
        state.isError = false;
        state.error = ''
 })
   
    .addCase(updateSingleJob.rejected,(state,action)=>{
        state.isUpdateJobSuccessFull = false;
       
        state.isLoading = false;
        // state.allJobs = [];
        state.isError = true;
        state.error = action.error?.message

    })
    .addCase(getSingleJob.pending,(state,action)=>{
        state.isError = false;
        state.isLoading = true;
    })

    .addCase(getSingleJob.fulfilled,(state,action)=>{
    

        state.jobDetails = action.payload;
        state.isLoading = false;
        state.isError = false;
        state.error = ''
 })
   
    .addCase(getSingleJob.rejected,(state,action)=>{
       
        state.isLoading = false;
       
        state.isError = true;
        state.error = action.error?.message

    })
  }
})



export const {editSingleJob,resetEditJob,isUpdateJob,resetToggleisUpdateJobSuccessFull}=jobSlice.actions;
export default jobSlice.reducer